import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useReservation from '../../hooks/useReservationData';
import moment from 'moment';
import { getTimeZones } from '../../services/timezone';
import { getBranches } from '../../services/branch';
import { getLocations } from '../../services/location';
import useWebData from '../../hooks/useWebData';
import { tenantId } from '../../config/api';

export const RedirectOnRefresh = () => {
    const {
        setPrimaryKey,
        setPickupDate,
        setReturnDate,
        setReservation,
        setCurrentPage,
        setIsNavigate,
        setCustomerId,
        setCustomerData,
        setLocalAddress,
        setConfirmSignatureURL,
        setBranchId,
        setBranches,
        setPickupLocationId,
        setReturnLocationId,
        setLocations,
        setLocationDataIsLoaded,
        setPickupLocationOptionsOfParticularBranch,
        setReturnLocationOptionsOfParticularBranch,
        setLocationOpenHourOfParticularBranch,
        setReturnToDifferent,
        setTimezoneOptions,
        setTimezoneOptionsIsLoaded,
        setPickupTime,
        setReturnTime,
        setSelectedVehicleClass,
        setAvailableVehicle,
        setVehicleClassId,
        setExtraValue,
        setCheckExtraValue,
        setTaxAmount,
        setMandatoryAdditionalChargesAmount,
        setGovernmentTaxAmount,
        setExtraValueLoaded
    }: any = useReservation();
    const { webData }: any = useWebData();
    const { isNavigate }: any = useReservation();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname === '/reservation' && !isNavigate) {
            navigate("/")
        }

        if (location.pathname === "/") {
            const currentDate = new Date().toISOString();
            setPickupDate(moment(currentDate).format("YYYY-MM-DD"));
            setReturnDate(moment(currentDate).add(1, 'day').format("YYYY-MM-DD"));
            setPrimaryKey(0);
            setReservation(null);
            setCurrentPage(0);
            setIsNavigate(false);
            setCustomerId(0);
            setCustomerData(null);
            setLocalAddress("");
            setConfirmSignatureURL(null);
            setBranchId("");
            setPickupLocationId("0");
            setReturnLocationId("0");
            setPickupLocationOptionsOfParticularBranch([]);
            setReturnLocationOptionsOfParticularBranch([]);
            setLocationOpenHourOfParticularBranch([]);
            setReturnToDifferent(false);
            setSelectedVehicleClass(null);
            setAvailableVehicle([]);
            setVehicleClassId("");
            setExtraValue([]);
            setCheckExtraValue([]);
            setTaxAmount(0);
            setMandatoryAdditionalChargesAmount(0);
            setGovernmentTaxAmount(0);
            setExtraValueLoaded(false);
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, navigate, webData]);


    useEffect(() => {
        if (location.pathname === "/") {
            getTimeZones(tenantId)
                .then(res => {
                    const data = res?.map((item: any) => ({
                        value: item?.id,
                        label: item?.name
                    }));
                    setTimezoneOptions(data);
                    setTimezoneOptionsIsLoaded(true);
                })
                .catch((error) => {
                    setTimezoneOptions([]);
                    setTimezoneOptionsIsLoaded(true);
                    console.error("Error:", error);
                });

            getBranches(tenantId)
                .then(data => {
                    setBranches(data);
                    if (data?.length <= 0) {
                        setBranchId("0");
                        const timeData = new Date().toLocaleString("en-US", {
                            timeZone: moment.tz.guess()
                        });

                        setPickupTime(moment(timeData).format('HH:mm'));
                        setReturnTime(moment(timeData).format('HH:mm'));

                        return;
                    }

                })
                .catch((error) => {
                    setBranches([]);
                    setBranchId("0");
                    const timeData = new Date().toLocaleString("en-US", {
                        timeZone: moment.tz.guess()
                    });

                    setPickupTime(moment(timeData).format('HH:mm'));
                    setReturnTime(moment(timeData).format('HH:mm'));

                    console.error(error);
                });

            setLocationDataIsLoaded(false);

            getLocations(tenantId)
                .then(data => {
                    setLocations(data);
                    setLocationDataIsLoaded(true);
                })
                .catch(error => {
                    setLocations([]);
                    setLocationDataIsLoaded(true);
                    console.error(error);
                });

        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    return null;
};
